import { localizationService } from '@shared-services/localization-service';
import React, { useMemo } from 'react';
import CalendarIcon from '../components/icons/CalendarIcon';
import ClockIcon from '../components/icons/ClockIcon';
import GlobeIcon from '../components/icons/GlobeIcon';

const useBookingMarkupData = () => {
    const date = useMemo(() => {
        const today = new Date();
        
        return {
            year: today.getFullYear(),
            month: today.toLocaleString('default', { month: 'long' }),
            day: today.getDate(),
            dayInWeek: today.toLocaleString('default', { weekday: 'short' }),
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        };
    }, []);

    const mockInfo = {
        userName: localizationService.str(
            'ui.runtimessr.calbooking.markup.userName'
        ),
        eventName: localizationService.str(
            'ui.runtimessr.calbooking.markup.eventType'
        ),
        data: [
            {
                value: '30m',
                icon: <ClockIcon />,
            },
            {
                value: 'Online Meeting',
                icon: <CalendarIcon />,
            },
            {
                value: date.timeZone,
                icon: <GlobeIcon />,
            },
        ],
    };

    return {
        date,
        mockInfo,
    };
};

export default useBookingMarkupData;
